// K6 — önceki yıla göre olağan dışı değer uyarısı (bloklamaz).
// Tek kural: |değer| / |önceki| oranı OUTLIER_FACTOR'dan büyük ya da
// 1/OUTLIER_FACTOR'dan küçükse oran döner, aksi null. Eşik ayarı yok (Finar a).

export const OUTLIER_FACTOR = 10;

/** Olağan dışıysa |value|/|prior| oranını, değilse null döner. */
export function outlierRatio(
  value: number,
  prior: number,
  factor: number = OUTLIER_FACTOR,
): number | null {
  if (!Number.isFinite(value) || !Number.isFinite(prior)) return null;
  if (prior === 0 || value === 0) return null;
  const r = Math.abs(value) / Math.abs(prior);
  return r > factor || r < 1 / factor ? r : null;
}

/**
 * Oranı kullanıcı metnine çevirir: ≥1 → "10,4 kat" / "1.000 kat", <1 → "1/10,4" / "1/100".
 * Kat < 100 iken bir ondalık, ≥100 tam sayı. Eşiği yalnız yuvarlamayla geçen oran ASLA
 * "10 kat" / "1/10" yazılmaz (kural "10 kattan fazla") — eşiğe düşen yuvarlama yukarı çekilir.
 */
export function formatOutlierRatio(r: number, factor: number = OUTLIER_FACTOR): string {
  const times = r >= 1 ? r : 1 / r;
  const text = formatTimes(times, factor);
  return r >= 1 ? `${text} kat` : `1/${text}`;
}

function formatTimes(times: number, factor: number): string {
  if (times >= 100) return Math.round(times).toLocaleString("tr-TR");
  let shown = Math.round(times * 10) / 10;
  // eşiği yalnız yuvarlamayla geçen oran: bir ondalık yukarı (10,04 → "10,1"; kayan nokta artığı dahil)
  if (times > factor && shown <= factor) shown = Math.max(Math.ceil(times * 10) / 10, factor + 0.1);
  return shown.toLocaleString("tr-TR", { maximumFractionDigits: 1 });
}

/**
 * Sıfır olmayan bir sayı standart biçimde "0" görünüyorsa (ör. 0,0004 iki ondalıkta) 3 önemli
 * basamakla yeniden yazar — "Önceki yıl 0, bu değer 5" çelişkisi olmasın.
 */
export function outlierDisplayNumber(n: number, formatted: string): string {
  if (n === 0 || !/^-?0$/.test(formatted)) return formatted;
  return n.toLocaleString("tr-TR", { maximumSignificantDigits: 3 });
}
